import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import investStock from "./investStock";

const {ccclass, property} = cc._decorator;

@ccclass
export default class investClean extends cc.Component {

    @property({type:cc.Sprite,displayName:"顶部图片"})
    topSp:cc.Sprite = null;

    @property({type:cc.Node,displayName:"胜利的按钮"})
    winBtns:cc.Node = null;

    @property({type:cc.Node,displayName:"失败的按钮"})
    loseBtns:cc.Node = null;

    @property({type:cc.Label,displayName:"下方文本"})
    bottomLb:cc.Label = null;

    @property({type:cc.Label,displayName:"买入价格"})
    lb_Buy:cc.Label = null;

    @property({type:cc.Label,displayName:"卖出价格"})
    lb_Sell:cc.Label = null;

    @property({type:cc.Label,displayName:"盈利价格"})
    lb_Profit:cc.Label = null;

    private currentMoney:number = 0;
    private investMoney:number = 0;

    private incomeMoney:number = 0;

    private canGetAward:boolean = true;

    investStock:investStock = null;

    bindData(investStock:investStock){
        console.log(investStock,"investStock");
        this.currentMoney = Math.floor(investStock.oneCopyMoney * investStock.currentCount);
        this.investMoney = Math.floor(investStock.investMoney);
        this.incomeMoney = this.currentMoney - this.investMoney;
        this.investStock = investStock;
        this.updateNode();
        this.canGetAward = true;
    }

    updateNode(){
        this.winBtns.active = false;
        this.loseBtns.active = false;
        this.lb_Buy.string = data_control.getNumberFormat(this.investMoney);
        this.lb_Sell.string = data_control.getNumberFormat(this.currentMoney);
        this.lb_Profit.string = data_control.getNumberFormat(this.incomeMoney);
        this.loadIcon();
        if(this.incomeMoney >= 0){
            // 赚了钱
            this.winBtns.active = true;
            this.bottomLb.string = "*观看广告可以获得三倍奖励哟~";
        }else{
            // 亏了钱
            this.loseBtns.active = true;
            this.bottomLb.string = "*观看广告可以保住本金哟~";
        }
    }

    loadIcon(){
        if(this.investStock.currentSelectItem){
            let spPath = this.investStock.currentSelectItem.icon;
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle);
            bundle.load(`assets/obj/${spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.debug("加载物品图片失败");
                    return;
                }
                this.topSp.spriteFrame = asset;
            });
        }
    }

    onBtnComit(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let targetNode:cc.Node = e.target;
        if(this.canGetAward){
            this.setCoins(this.currentMoney,true,targetNode);
            this.canGetAward = false;
        }
        this.closeThis();
    }

    onBtnSanBei(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let targetNode:cc.Node = e.target;
        utilsModel.loadAndShowVideoAdTrans(()=>{
            let two = this.incomeMoney * 2;
            let money = two + this.currentMoney;
            if(this.canGetAward){
                this.setCoins(money,true,targetNode)
                this.canGetAward = false;
            }
            this.closeThis();
        },()=>{

        },null,"投资项目看广告获得三倍");
    }

    onBtnBaoZhu(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let targetNode:cc.Node = e.target;
        utilsModel.loadAndShowVideoAdTrans(()=>{
            if(this.canGetAward){
                this.setCoins(this.investMoney,true,targetNode);
                this.canGetAward = false;
            }
            this.closeThis();
        },()=>{

        },null,"投资项目看广告保住本金");
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(this.canGetAward){
            this.setCoins(this.currentMoney,true);
            this.canGetAward = false;
        }
        this.closeThis();
    }

    setCoins(coins: number, isPlus: boolean, node?: cc.Node) {
        let tPos = this.investStock.coinNode?.convertToWorldSpaceAR(cc.v2(0,0));
        O1HD.getServices().userSrv.setCoins(coins, isPlus, node, tPos);
        
    }

    closeThis(){
        this.node.active = false;
        this.investStock.closeThis();
    }
    
}
